import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyMccViewQuery,
  useMccCreateMutation,
  useMccUpdateMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const MCC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;
  const [btn, setBtn] = useState(false);

  const [name, setname] = useState("");
  const [amount, setamount] = useState("");
  const [description, setdescription] = useState("");
  const [percentage, setpercentage] = useState("");
  const [total_amount, settotal_amount] = useState("");
  const [nameErr, setnameErr] = useState(false);
  const [amountErr, setamountErr] = useState(false);
  const [descriptionErr, setdescriptionErr] = useState(false);
  const [percentageErr, setpercentageErr] = useState(false);
  const [total_amountErr, settotal_amountErr] = useState(false);

  const [mccCreateApi] = useMccCreateMutation();
  const [mccUpdateApi] = useMccUpdateMutation();
  const [mccViewApi] = useLazyMccViewQuery();

  const submitHandler = () => {
    if (name?.length == 0 || amount?.length == 0 || description?.length == 0) {
      setnameErr(true);
      setamountErr(true);
      setdescriptionErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      formdata.append("amount", amount);
      formdata.append("description", description);

      dispatch(saveLoader(true));
      setBtn(true);
      if (location?.state?.type == "edit") {
        formdata.append("_method", "PUT");
        mccUpdateApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: "Mcc Edited Successfully",
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            console.log("err", err);
            dispatch(saveLoader(false));
            setBtn(false);
          });
      } else {
        mccCreateApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: "Mcc Added Successfully",
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            console.log("err", err);
            dispatch(saveLoader(false));
            setBtn(false);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    mccViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        let data = res?.subscription;
        if (data?.name) {
          setname(data?.name);
        }

        if (data?.amount) {
          setamount(data?.amount);
        }

        if (data?.description) {
          setdescription(data?.description);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  const percentageCalculation = (amount_, percen_) => {
    let amount = amount_ ? +amount_ : 0;
    let percen = percen_ ? +percen_ : 0;

    let percens = (+amount * +percen) / 100;
    let sum = Number(+percens + +amount_).toFixed(2);
    setamount(+amount_);
    setpercentage(+percen_);
    settotal_amount(+sum);
  };

  useEffect(() => {
    if (location?.state?.type == "edit") {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={
          types == "view"
            ? "view-mcc"
            : types == "edit"
            ? "edit-mcc"
            : "add-mcc"
        }
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Mcc Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setname(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Mcc Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Amount{" "}
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) =>
                    percentageCalculation(e.target.value, percentage)
                  }
                  value={amount}
                  type={"number"}
                />
              </div>
              {amount?.length == 0 && amountErr && (
                <p className="err">Enter Amount</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Tax Percentage %
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  type={"number"}
                  onChange={(e) =>
                    percentageCalculation(amount, e.target.value)
                  }
                  value={percentage}
                />
              </div>
              {percentage?.length == 0 && percentageErr && (
                <p className="err">Enter Tax Percentage</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Total Amount
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  type={"number"}
                  readOnly
                  //   onChange={(e) => settotal_amount(e.target.value)}
                  value={total_amount}
                />
              </div>
              {total_amount?.length == 0 && total_amountErr && (
                <p className="err">Enter Total Amount</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Description
                </label>
                <textarea
                  rows={4}
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setdescription(e.target.value)}
                  value={description}
                />
              </div>
              {description?.length == 0 && descriptionErr && (
                <p className="err">Enter Description</p>
              )}
            </div>
          </Row>
          <Row>
            {types == "view" ? null : (
              <div className="col-md-12 text-center mt-4 mb-4">
                <button
                  className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                  onClick={() => submitHandler()}
                  disabled={btn}
                >
                  Save
                </button>
              </div>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default MCC;
